import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scheduleScrollToPageTop } from './navSameRouteClick';

/** Scroll to top on route change (fixes mobile nav leaving the viewport mid-page). */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    return scheduleScrollToPageTop({ smooth: false });
  }, [pathname, search, hash]);

  return null;
}
